export const FormStyles = {
  input:
    'block w-full font-apercu-mono rounded-input bg-chinese-black border-chinese-black shadow-sm text-white disabled:text-chinese-silver focus:border-chinese-black focus:ring-chinese-black text-sm sm:text-base px-3.5 pb-2.5 pt-3',
};
